module.exports = "/images/avatar.svg?5e0d3cd2e3749de90d6fc90a90b4cde3";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/images/avatar.svg
// module id = P3eV
// module chunks = 0